<template>
  <div class="header">
    <el-row :gutter="10">
      <el-col :span="18" class="header-left">
        <img src="./images/logo-top.png" alt class="logo" @click="home" />
        <div class="lf top-xbdk">
          <img src="./images/top-xb1.png" class="top-xb" />
          <span class="top-xbm">15,581,655,990张 数字小票已为绿色环保节约了</span>
          <img src="./images/top-xb2.png" class="top-xb" />
          <span class="top-xbm">8,258,277升水</span>
          <img src="./images/top-xb3.png" class="top-xb" />
          <span class="top-xbm">
            3,427,964棵树
            <span @click="clickF" class="clickF">…</span>
          </span>
        </div>
      </el-col>
      <el-col :span="6" class="header-right">
        <el-button type="text" class="text-btn" @click="jumpOpenUp">食药健康生态数据服务</el-button>
        <el-button type="text" class="text-btn" @click="openZpt">财税生态数据服务</el-button>
        <!-- <el-button type="text" class="text-btn color-btn" @click="openZpt">免费开通</el-button> -->
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  methods: {
    jumpOpenUp() {
      // window.open('http://healthyweb.gooagoo.com/home', '_blank')
      window.open("http://healthyweb.gooagoo.com/home");
    },
    openZpt() {
      window.open("http://taxweb.dev.goago.cn/pages/home");
    },
    home() {
      window.open("http://www.ddriven-tech.com/");
    },
    clickF() {
      window.open("http://shuyan.51xly.com.cn/index.php/Home/Index/cover.html");
    }
  }
};
</script>

<style lang="stylus" scoped>
.header
  height 60px
  line-height 60px
  color #fff
  background #2C2F3A
  padding 0 30px
  .header-left
    text-align left
  .header-right
    text-align right
    .text-btn
      color #fff
      &:hover
        color #1586d3
    .color-btn
      background #EA5006
      border 1px solid #EA5006
  .logo
    height 35px
    vertical-align middle
    margin-right 30px
    float left
    margin-top 13px
    cursor pointer
  .title
    font-size 18px
    font-weight 700
  /* vertical-align middle */
  .user-info
    font-size 20px
    text-align center
.lf
  float left
  display block
.top-xbdk
  padding 2.5px 0 6.5px 0
.top-xb
  float left
  display inline-block
.top-xbm
  display inline-block
  float left
  line-height 56px
  font-size 14px
  color #69a424
  padding-left 12px
  padding-right 20px
.clickF
  color #69a424
  cursor pointer
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue